import { GlobalState } from '@leverege/ui-redux';
const RESOURCES = [{
  urlPattern: 'companies',
  name: 'companies'
}, {
  urlPattern: 'locations',
  name: 'locations'
}, {
  urlPattern: 'assetsLocators',
  name: 'equipment'
}, {
  urlPattern: 'assetsTags',
  name: 'assetTags'
}, {
  urlPattern: 'agEquipmentTypes',
  name: 'equipmentTypes'
}, {
  urlPattern: 'parentTransfers',
  name: 'transfers'
}, {
  urlPattern: 'dataSharingAssetsLocators',
  name: 'sharedEquipment'
}, {
  urlPattern: 'dataSharingLocators',
  name: 'sharedLocators'
}, {
  urlPattern: 'cases',
  name: 'thefts'
}, {
  urlPattern: 'locators',
  name: 'locators'
}, {
  urlPattern: 'tags',
  name: 'tags'
}, {
  urlPattern: 'floors',
  name: 'floors'
}, {
  urlPattern: 'zones',
  name: 'geofences'
}, {
  urlPattern: 'overview',
  name: 'overview'
}, {
  urlPattern: 'access',
  name: 'users'
}, {
  urlPattern: 'beacons',
  name: 'beacons'
}, {
  urlPattern: 'gateways',
  name: 'gateways'
}, {
  urlPattern: 'info',
  name: 'info'
}];
const HIERARCHY_LEVELS = [{
  urlPattern: 'organization',
  name: 'organization'
}, {
  urlPattern: 'company',
  name: 'company'
}, {
  urlPattern: 'location',
  name: 'location'
}];
function checkPath(pagePath) {
  if (!pagePath) return null;
  const normalizedPath = pagePath.split('?')[0];
  const segments = normalizedPath.split('/').filter(Boolean);
  const hierarchy = [];
  const resources = [];
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const next = segments[i + 1];
    const hierarchyMatch = HIERARCHY_LEVELS.find(h => h.urlPattern.toLowerCase() === segment.toLowerCase());
    if (hierarchyMatch) {
      hierarchy.push(hierarchyMatch.name);
      if (next) {
        i++;
      }
      continue;
    }
    const resourceMatch = RESOURCES.find(r => r.urlPattern.toLowerCase() === segment.toLowerCase());
    if (resourceMatch) {
      resources.push(resourceMatch.name);
    }
  }
  const path = [...hierarchy, ...resources].join('.');
  return {
    path,
    pageType: resources.at(-1) || null,
    hierarchyLevel: hierarchy.length
  };
}
function getPreviousPageType(referrer) {
  if (!referrer) return null;
  try {
    const url = new URL(referrer);
    const path = url.pathname;
    const segments = path.split('/').filter(Boolean);
    for (let i = segments.length - 1; i >= 0; i--) {
      const match = RESOURCES.find(r => r.urlPattern.toLowerCase() === segments[i].toLowerCase());
      if (match) {
        return match.name;
      }
    }
    return segments.at(-1);
  } catch {
    return null;
  }
}
export default {
  id: 'molten.AmplitudePageViewTracking',
  onLoggedIn: (molten, action) => {
    molten.addPlugin('AmplitudePlugin', {
      init() {
        return {
          name: 'page-view-tracking-enrichment',
          type: 'enrichment',
          setup: async () => undefined,
          execute: async event => {
            if (event.event_type !== '[Amplitude] Page Viewed') {
              return event;
            }
            const referrer = document.referrer;
            const exactPath = window.location.pathname;
            const pagePath = window.location.href;
            const enhancedProperties = {
              ...event.event_properties
            };
            const pathInfo = checkPath(pagePath);
            if (pathInfo) {
              enhancedProperties.path = pathInfo.path;
              enhancedProperties.pageType = pathInfo.pageType;
              enhancedProperties.hierarchyLevel = pathInfo.hierarchyLevel;
            }
            enhancedProperties.url = exactPath;
            if (referrer) {
              enhancedProperties.referrer = referrer;
              enhancedProperties.referring_domain = new URL(referrer).host;
              enhancedProperties.previousPage = getPreviousPageType(referrer);
            }
            event.event_properties = enhancedProperties;
            return event;
          }
        };
      }
    });
  }
};